import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    FETCH_ALL_FEATURE,
    UPDATE_FEATURE,
    CREATE_FEATURE, DELETE_FEATURE
} from 'constants/features.constants'
import axios from 'axios'
import {
    fetchFeaturesSuccess,
    updateFeatureSuccess,
    createFeatureSuccess,
    deleteFeatureSuccess
} from "actions/features.action";
import { showErrors, stopLoader } from "actions/general.action";


// feature sagas

const fetchFeaturesRequest = async (page) => {
    return axios.get('/api/v1/super_admin/features');
}

function* fetchFeatures({ payload }) {
    try {
        const reuslt = yield call(fetchFeaturesRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchFeaturesSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const updateFeaturesRequest = async (payload) => {
    let o = Object.assign({}, payload);
    o.partner_type = { id: payload.feature_type_id }
    o.country = { id: payload.country_id }

    return axios.put('/api/v1/super_admin/features/' + payload.id,
        o
    );
}

function* updateFeature({ payload }) {
    try {
        const reuslt = yield call(updateFeaturesRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(updateFeatureSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const createFeaturesRequest = async (payload) => {
    let o = { feature_type: { id: payload.feature_type_id }, name: payload.name }

    o.selected_sub_features = []
    console.log(payload)
    payload.ids.forEach(function (sub) {
        let d = {
            "sub_feature": {
                "id": sub
            },
            "feature_type": {
                "id": payload.feature_type_id
            }
        }
        if (sub === 1) {
            let op = {
                video_consult_limit: payload.video_consult_limit,
                video_limit_condition_period: payload.video_limit_condition_period,
                video_specialities: payload.video_specialities
            }
            d["option"] = op
        } else if (sub === 3) {

            let op = {
                chat_limit_needed: payload.chat_limit_needed,
                duration_before_consult: payload.duration_before_consult,
                duration_after_consult: payload.duration_after_consult
            }
            d["option"] = op
        } else if (sub === 4) {
            let op = {
                translator_second_lang: payload.translator_second_lang,
                translator_first_lang: payload.translator_first_lang
            }
            d["option"] = op
        }
        o.selected_sub_features.push(d)
    });
    console.log(o)
    return axios.post('/api/v1/super_admin/features',
        o
    );
}

function* createFeature({ payload }) {
    try {
        const reuslt = yield call(createFeaturesRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield all([
                put(createFeatureSuccess(reuslt.data)),
                //put(stopLoader("Feature created"))
            ])
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const deleteFeaturesRequest = async (id) => {
    return axios({
        method: "delete",
        url: '/api/v1/super_admin/features/' + id,
        headers: {
          'Content-Type': 'text/plain'
        },
        data: "",
    });
}

function* deleteFeature({ payload }) {
    try {
        const reuslt = yield call(deleteFeaturesRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(deleteFeatureSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}


// fork feature
export function* forkFetchFeatures() {
    yield takeEvery(FETCH_ALL_FEATURE, fetchFeatures);
}

export function* forkUpdateFeature() {
    yield takeEvery(UPDATE_FEATURE, updateFeature);
}

export function* forkCreateFeature() {
    yield takeEvery(CREATE_FEATURE, createFeature);
}

export function* forkDeleteFeature() {
    yield takeEvery(DELETE_FEATURE, deleteFeature);
}


export default function* rootSaga() {
    yield all([
        fork(forkFetchFeatures),
        fork(forkUpdateFeature),
        fork(forkCreateFeature),
        fork(forkDeleteFeature),
    ]);
}